var render, staticRenderFns
import script from "./VRadioGroup.vue?vue&type=script&lang=ts"
export * from "./VRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./VRadioGroup.vue?vue&type=style&index=0&id=70399156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70399156",
  null
  
)

export default component.exports